<template>
	<section class="premium-benefits-section bg-color-content-primary">
		<div class="container py-225">
			<div class="display-flex flex-direction-column align-items-center gap-300 my-150 mb-0-md">
				<div class="display-flex flex-direction-row-lg flex-direction-column align-items-flex-start gap-300">
					<div class="display-flex flex-direction-column gap-100 mb-200-smo text-color-white flex-1-md">
						<h3 class="heading-2">Benefits that grow with&nbsp;you</h3>
						<p class="body-lg-md body-md mt-0"
							>When your account reaches $100,000 or more, you'll gain access to premium&nbsp;features.</p
						>
					</div>
					<div class="display-flex flex-direction-column-smo align-items-flex-start gap-300 gap-225-mdo">
						<div
							v-for="(benefit, i) in benefits"
							:key="i"
							class="premium-benefit-tile p-200 p-150-mdo display-flex flex-direction-column align-items-flex-start gap-100"
						>
							<BaseSvgIcon class="premium-icon" :name="benefit.icon" height="32" width="32" />
							<div class="display-flex flex-direction-column flex-1 gap-50 text-color-white">
								<div class="heading-5">{{ benefit.heading }}</div>
								<p class="body-sm-md body-md mt-0" v-html="deorphanText(benefit.description)"></p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
import { deorphanText } from '@filters/shared-filters';
import { PremiumBenefit } from 'types/marketing-site';

const benefits: Array<PremiumBenefit> = [
	{
		icon: 'bank',
		heading: 'Exclusive investments',
		description:
			'We periodically offer private investment vehicles to take advantage of unique windows of opportunity.'
	},
	{
		icon: 'user-multiple',
		heading: 'White-glove support',
		description:
			'We have a small, elite team dedicated to supporting high-end clients who may require more sophisticated solutions.'
	},
	{
		icon: 'cash-stack',
		heading: 'No advisory fees*',
		description:
			'We will waive your advisory fee (0.15%) for the subsequent 12 months when you reach $100,000 in AUM for the first time.'
	}
];
</script>
<style lang="scss">
@use '../../../styles/utilities/respond-to.scss' as *;
@use '../../../styles/constants/colors.scss' as *;

.premium-benefits-section {
	.premium-benefit-tile {
		border: 1px solid gray(60);
		border-radius: 8px;
		align-self: stretch;

		@include respond-to(md) {
			width: 216px;
		}

		@include respond-to(lg) {
			width: 237px;
		}
	}

	.premium-icon {
		color: gold(70);
	}
}
</style>
